import createApiSlice from "./apiSlice";

// Create slices for two different API endpoints
export const { fetchData: fetchLoggedInUser, reducer: loggedInUserReducer } = createApiSlice("loggedInUser", "user");

export const { fetchData: fetchQuickReportAccess, reducer: quickReportAccessReducer } = createApiSlice("quickReportAccess", (params) => {
  return `user/${params.userId}/management-user-report-access`;
});

export const { fetchData: fetchLoanDetails, reducer: loanDetailsReducer } = createApiSlice("loanDetails", ({ leadID }) => {
  return `lead/${leadID}/loan-details`;
});

export const { fetchData: fetchCreditDetail, reducer: creditDetailReducer } = createApiSlice("creditDetail", ({ leadID }) => {
  return `lead/credit-detail?leadID=${leadID}`;
});
